import { createTheme } from '@mui/material';

// Diferentes estilos para un componente
import { BackButtonStyles } from './MUI-Variants/BackButton';
import { SubmitButtonStyles } from './MUI-Variants/SubmitButton';
import { SecondSubmitButtonStyles } from './MUI-Variants/SecondSubmitButton';
import { CancelButtonStyles } from './MUI-Variants/CancelButton';
import { AcceptButtonStyles } from './MUI-Variants/AcceptButton';

const theme = createTheme({
    typography: {
        fontFamily: "'Poppins', sans-serif"
    },
    components: {
        MuiTextField: {
            styleOverrides: {
                root: {
                    color: "white",
                    "& .MuiInputBase-root": {
                        fontFamily: '"Poppins", sans-serif',
                        color: "#173456",
                        fontWeight: 500,
                        backgroundColor: "#fafafa",
                        borderRadius: "15px",
                        display: "flex",
                        alignItems: "center",
                    },
                    '& label.Mui-focused': {
                        color: '#173456',
                    },
                    "& .MuiText": {
                        color: "#173456"
                    },
                    "& .MuiFormLabel-root": {
                        color: "#173456"
                    },
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            color: '#173456',
                            borderColor: '#173456',
                        },
                        '&:hover fieldset': {
                            color: '#173456',
                            borderColor: '#173456',
                        },
                        '&.Mui-focused fieldset': {
                            color: '#173456',
                            borderColor: '#173456',
                        },
                    },
                }
            }
        },
        MuiSwitch: {
            styleOverrides: {
                root: {
                    width: 42,
                    height: 26,
                    padding: 0,
                    '& .MuiSwitch-switchBase': {
                        padding: 0,
                        margin: 2,
                        transitionDuration: '300ms',
                        '&.Mui-checked': {
                            transform: 'translateX(16px)',
                            color: '#fff',
                            '& + .MuiSwitch-track': {
                                backgroundColor: '#65C466',
                                opacity: 1,
                                border: 0,
                            },
                            '&.Mui-disabled + .MuiSwitch-track': {
                                opacity: 0.5,
                            },
                        },
                        '&.Mui-focusVisible .MuiSwitch-thumb': {
                            color: '#33cf4d',
                            border: '6px solid #fff',
                        },
                        '&.Mui-disabled .MuiSwitch-thumb': {
                            color: '#FAFAFA',
                        },
                        '&.Mui-disabled + .MuiSwitch-track': {
                            opacity: 0.7 ,
                        },
                    },
                    '& .MuiSwitch-thumb': {
                        boxSizing: 'border-box',
                        width: 22,
                        height: 22,
                    },
                    '& .MuiSwitch-track': {
                        borderRadius: 26 / 2,
                        backgroundColor: '#E9E9EA',
                        opacity: 1,
                    },
                }
            }
        },
        MuiTypography:{
            styleOverrides:{
                root:{
                    fontFamily: '"Poppins", sans-serif',
                    color: "#173456"
                }
            }
        },
        MuiAlert: {
            styleOverrides: {
                root: {
                    fontWeight: "bold",
                    fontFamily: '"Poppins", sans-serif',
                },
                filledSuccess: {
                    backgroundColor: "#daffdc",
                    color: "#0abc11",
                },
                filledError: {
                    backgroundColor: "#fac1c1ff",
                    color: "#ff1818ff",
                },
                filledWarning: {
                    backgroundColor: "#fff6baff",
                    color: "#ff9f18ff",
                },
                filledInfo: {
                    backgroundColor: "#d4f7feff",
                    color: "#1865ffff",
                }
            }
    },
    MuiButton: {
            defaultProps: {
                color: "primary",
            },
            styleOverrides: {
                contained: {
                    backgroundColor: "#183555",
                    color: "#fff",
                    "&:hover": {
                        backgroundColor: "#122f47",
                    },
                },
                outlined: {
                    borderColor: "#183555",
                    color: "#183555",
                    "&:hover": {
                        backgroundColor: "rgba(24,53,85,0.04)",
                    },
                },
                text: {
                    color: "#183555",
                    "&:hover": {
                        backgroundColor: "rgba(24,53,85,0.04)",
                    },
                },
                root: {
                    fontFamily: '"Poppins", sans-serif',
                    textTransform: 'capitalize',
                    fontWeight: 600,
                    letterSpacing: '0.7px',
                    height: '45px',
                    fontSize: '0.95rem',
                    "&:disabled": {
                        backgroundColor: "#cacaca",
                        color: "#303030"
                    },
                }
            },
            variants: [
                BackButtonStyles, 
                SubmitButtonStyles,
                SecondSubmitButtonStyles,
                CancelButtonStyles,
                AcceptButtonStyles
            ]
        },
        MuiRadio: {
            styleOverrides: {
                root: {
                    color: "#173456", 
                    '&.Mui-checked': { 
                        color: "#173456"
                    },
                    '&.Mui-disabled': {
                        opacity: 0.5,
                    },
                }
            }
        },
        
        MuiIconButton: {
            defaultProps: {
                color: "primary",
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    "&.MuiChip-colorInfo": {
                        backgroundColor: "#183555",
                        color: "#fff",
                    },
                },
            },
        },
        MuiAvatar: {
            styleOverrides: {
                root: {
                    backgroundColor: "#183555",
                    color: "#fff",
                },
            },
        },
        MuiCircularProgress: {
            defaultProps: {
                color: "primary",
            },
        },
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    color: "#173456",
                    '&.Mui-checked': { 
                        color: "#173456"
                    },
                    '&.Mui-disabled': {
                        opacity: 0.5,
                    },
                }
            }
        },
        MuiPagination: {
            styleOverrides: {
                root: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    margin: "20px 0",
                    "& .MuiPaginationItem-root": {
                        color: "#666666",
                        fontFamily: '"Poppins", sans-serif',
                        fontWeight: 600,
                        letterSpacing: '0.7px',
                        "&.Mui-selected": {
                            backgroundColor: "#173456",
                            color: "#fff"
                        }
                    }
                }
            }
        },
    }
})

export default theme